export enum SystemSettingKey {
  PLAN_YEARLY_MERGE_FINISHED_AT = 'PLAN_YEARLY_MERGE_FINISHED_AT',
  ACCUMULATION_MERGE_INTERVAL_DAYS = 'ACCUMULATION_MERGE_INTERVAL_DAYS',
  SUBJECT_SALES_REVENUE_ID = 'SUBJECT_SALES_REVENUE_ID',
  SUBJECT_VARIABLE_COSTS_ID = 'SUBJECT_VARIABLE_COSTS_ID',
  SUBJECT_OPERATING_PROFIT_ID ='SUBJECT_OPERATING_PROFIT_ID',
  SKIP_REPORTS_DEPARTMENT_IDS = 'SKIP_REPORTS_DEPARTMENT_IDS'
}

/**
 * 从system_setting配置中获取指定key的值
 * @param systemSettingConfig system_setting配置数组
 * @param key 配置键名
 * @param defaultValue 默认值
 * @returns 配置值或默认值
 */
export function getSystemSettingValue(
  systemSettingConfig: Array<{ key: string; value: string }> | null,
  key: string,
  defaultValue: string = ''
): string {
  if (!systemSettingConfig || !Array.isArray(systemSettingConfig)) {
    return defaultValue;
  }
  
  const setting = systemSettingConfig.find(item => item.key === key);
  return setting?.value || defaultValue;
}

/**
 * 获取合并间隔天数，用于计算deadline
 * @param systemSettingConfig system_setting配置数组
 * @returns 合并间隔天数，默认为30天
 */
export function getAccumulationMergeIntervalDays(
  systemSettingConfig: Array<{ key: string; value: string }> | null
): number {
  const value = getSystemSettingValue(systemSettingConfig, SystemSettingKey.ACCUMULATION_MERGE_INTERVAL_DAYS, '30');
  const days = parseInt(value, 10);
  return Number.isNaN(days) ? 30 : days;
}

/**
 * 获取需要跳过显示的部门ID列表
 * @param systemSettingConfig system_setting配置数组
 * @returns 部门ID数组
 */
export function getSkipReportsDepartmentIds(
  systemSettingConfig: Array<{ key: string; value: string }> | null
): string[] {
  const value = getSystemSettingValue(systemSettingConfig, SystemSettingKey.SKIP_REPORTS_DEPARTMENT_IDS, '[]');
  
  try {
    // 尝试直接解析JSON
    const parsed = JSON.parse(value);
    const result = Array.isArray(parsed) ? parsed.map(id => String(id)) : [];
    return result;
  } catch (error) {
          // 错误处理
    // 如果JSON解析失败，尝试修复格式（为UUID添加引号）
    try {
      // 匹配UUID格式并添加引号
      const fixedValue = value.replace(/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/g, '"$1"');
      
      const parsed = JSON.parse(fixedValue);
      const result = Array.isArray(parsed) ? parsed.map(id => String(id)) : [];
      return result;
    } catch (secondError) {
      return [];
    }
  }
}